// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8a7833fe","198":"011266ca","404":"7b8ba0b1","415":"41100d7e","498":"d3203155","733":"40f2af42","787":"a1583515"}[chunkId] + ".chunk.js";
};